const navUtils = {
  resolveNavComp : item => {
    if (item.cap) return 'bo-nav-cap'
    if (item.children) return 'bo-nav-group'
    return 'bo-nav-link'
  }
}
export default navUtils
